import { Module } from 'vuex'
import { SearchState } from '../types/SearchState'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'
import { state } from './state'

export const module: Module<SearchState, any> = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state
}
